import { LinearProgress, withStyles } from "@material-ui/core";

const BorderLinearProgress = withStyles((theme) => ({
  root: (props) => ({
    height: "1.6rem",
    borderRadius: 10,
    backgroundColor: props.bgcolor ? props.bgcolor : null,
  }),
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: (props) => ({
    borderRadius: 5,
    backgroundColor: props.colorbar ? props.colorbar : "#17325C",
    opacity: 1,
  }),
}))(LinearProgress);

export default BorderLinearProgress;
